import React from 'react'

const date = new Date()
const footerYear = date.getFullYear()

const FooterView =  (props) => (
  <footer className={props.footerClass}>
    <div className="footer-wrap">
      <p>© {footerYear} SOLPAC Co.,Ltd. All rights reserved.</p>
    </div>
  </footer>
)

export default class footerClass extends React.PureComponent {

  render() {
    let footerClassName = (this.props.isModalFooter) ? 'l-footer modal-footer' : 'l-footer'
    return <FooterView footerClass={footerClassName} />
  }
}


// WEBPACK FOOTER //
// ./src/Home/Footer.js